import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import DeleteAccountModal from './components/DeleteAccount';
import AddUserAccountModal from './components/AddUserAccountModal';
import { convertTimestampToTime } from '../../common/globalUtils';
import {
  MAXIMUM_ACCOUNTS_NUMBER,
  ADD_NEW_ACCOUNT_ACTION_TYPE,
  EDIT_ACCOUNT_ACTION_TYPE,
  TIME_TO_TRIAL_IN_SECONDS,
} from './constants/UserManagementConstants';
import http from '../../common/http';
import { apiEndPoints } from '../../common/globalConstants';
import { getLoginRedirectUrl } from '../home/sharedFunctions';
import PropTypes from 'prop-types';

const initialState = {
  isAddNewAccount: false,
  addNewAccountActionType: ADD_NEW_ACCOUNT_ACTION_TYPE,
  selectedAccountData: {},
  showConfirmDeleteModal: false,
};
class UserManagement extends Component {

  static propTypes = {
    actions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidMount() {
    ReactGA.pageview('/dashboard/user-management');

    const checkAuthTokenRequest = http.get(apiEndPoints.authentication.CHECK_TOKEN);
    checkAuthTokenRequest.then(
      response => {
        const { retrieveOrganizationAccount, retrieveAllUsers } = this.props.actions;
        retrieveOrganizationAccount();
        retrieveAllUsers();
      },
      error => {
        this.props.history.push(getLoginRedirectUrl());
        return false;
      },
    );
  }

  isNoAccountAdded = () => {
    const { accounts } = this.props.userManagement;
    return accounts.length === 0;
  };

  isShowAddAccountBtn = () => {
    const { accounts } = this.props.userManagement;
    return accounts.length < MAXIMUM_ACCOUNTS_NUMBER;
  };

  showAddAccountPopup = () => {
    this.setState({
      isAddNewAccount: true,
      addNewAccountActionType: ADD_NEW_ACCOUNT_ACTION_TYPE,
    });
  };

  renderAddNewAccountBtn = () => {
    return (
      <button
        className={`${
          this.isShowAddAccountBtn() ? 'btn btn-outline-primary btn-add-user' : 'hidden'
        }`}
        onClick={this.showAddAccountPopup}
      >
        Add Another User
      </button>
    );
  };

  onSubmitAddAccountModal = userAccount => {
    const { addNewAccountActionType, selectedAccountData } = this.state;
    const { addNewAccount, updateUserAccount } = this.props.actions;
    if (addNewAccountActionType === ADD_NEW_ACCOUNT_ACTION_TYPE) {
      addNewAccount(userAccount);
    } else {
      updateUserAccount(selectedAccountData.id, userAccount);
    }
    this.setState({
      selectedAccountData: {},
    });
  };

  onDeleteAccount = () => {
    const { deleteUserAccount } = this.props.actions;
    const { selectedAccountData } = this.state;
    deleteUserAccount(selectedAccountData.id);
    this.setState({
      selectedAccountData: {},
      showConfirmDeleteModal: false,
    });
  };

  renderAddNewAccountModal = () => {
    const { isAddNewAccount, addNewAccountActionType, selectedAccountData } = this.state;
    const { accounts, isShowSubmitAddUserResult } = this.props.userManagement;
    const { toggleShowSubmitAddUserResult } = this.props.actions;
    return (
      isAddNewAccount && (
        <AddUserAccountModal
          isShow={isAddNewAccount}
          toggleModal={e => this.setState({ isAddNewAccount: e })}
          submit={this.onSubmitAddAccountModal}
          accounts={accounts}
          type={addNewAccountActionType}
          accountData={selectedAccountData}
          isShowResult={isShowSubmitAddUserResult}
          toggleShowSubmitAddUserResult={toggleShowSubmitAddUserResult}
        />
      )
    );
  };

  renderDeleteAccountModal = () => {
    const { showConfirmDeleteModal, selectedAccountData } = this.state;
    return (
      showConfirmDeleteModal && (
        <DeleteAccountModal
          isShow={showConfirmDeleteModal}
          toggleModal={e => this.setState({ showConfirmDeleteModal: e })}
          account={selectedAccountData}
          onDelete={this.onDeleteAccount}
        />
      )
    );
  };

  onClickEditBtn = account => {
    this.setState({
      isAddNewAccount: true,
      addNewAccountActionType: EDIT_ACCOUNT_ACTION_TYPE,
      selectedAccountData: { ...account },
    });
  };

  onClickDeleteBtn = account => {
    this.setState({
      showConfirmDeleteModal: true,
      selectedAccountData: account,
    });
  };

  renderAccounts = () => {
    const { accounts } = this.props.userManagement;
    return accounts.map((user, idx) => {
      return (
        <React.Fragment key={user.email}>
          <div className="item">{idx + 1}</div>
          <div className="item">
            <b>{user.name}</b>
          </div>
          <div className="item">{user.designation}</div>
          <div className="item">{user.email}</div>
          <div className="item">
            <button className="btn" onClick={() => this.onClickEditBtn(user)}>
              <i className="la la-edit" />
            </button>
            <button className="btn">
              <i className="la la-trash" onClick={() => this.onClickDeleteBtn(user)} />
            </button>
          </div>
        </React.Fragment>
      );
    });
  };

  renderAccountTable = () => {
    return (
      <div className="user-list">
        <div className="item item-label"></div>
        <div className="item item-label">Name</div>
        <div className="item item-label">Designation</div>
        <div className="item item-label">Email</div>
        <div className="item item-label"></div>
        {this.isNoAccountAdded() ? (
          <div className="item no-account">No account</div>
        ) : (
          this.renderAccounts()
        )}
      </div>
    );
  };

  renderOrganizationInfo = () => {
    const { organization } = this.props.userManagement;
    const timeForEndTrial = organization.registeredTime + TIME_TO_TRIAL_IN_SECONDS;
    return (
      <div className="company-info">
        <div className="label">Organization:</div>
        <div>{organization.name}</div>
        <div className="label">Trial ends on:</div>
        <div>{convertTimestampToTime(timeForEndTrial)}</div>
      </div>
    );
  };

  render() {
    return (
      <div className="user-management-container">
        <h5>Manage Organization Trial</h5>
        {this.renderOrganizationInfo()}
        <div className="user-list-container">
          <div className="d-flex flex-row align-items-baseline">
            <h5>Current Users </h5>
            <span className="accounts-range">(Maximum {MAXIMUM_ACCOUNTS_NUMBER})</span>
          </div>
          {this.renderAccountTable()}
        </div>
        {this.renderAddNewAccountBtn()}
        {this.renderAddNewAccountModal()}
        {this.renderDeleteAccountModal()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userManagement: state.userManagement,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);



// WEBPACK FOOTER //
// ./src/features/user-management/UserManagement.js